import { html } from 'lit';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import { LightDomSlotFallbackController } from '../../lib/light-dom-slot-fallback/light-dom-slot-fallback-controller.js';
import { CrntIcon } from '../icon/icon.component.js';
import formControlValidationStyles from './form-control-validation-message.css.js';

class CrntFormControlValidationMessage extends CrntElement {
  constructor() {
    super(...arguments);
    this._lightDomSlotFallbackController = new LightDomSlotFallbackController(this, [
      () => ({
        fallbackElement: () => {
          const icon = document.createElement("crnt-icon");
          icon.icon = "triangle-exclamation";
          return icon;
        },
        slotName: "icon"
      })
    ]);
  }
  static {
    this.dependencies = {
      [CrntIcon.tagName]: CrntIcon
    };
  }
  static {
    this.styles = trustedCSS(formControlValidationStyles);
  }
  static {
    this.tagName = "crnt-form-control-validation-message";
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this._lightDomSlotFallbackController.setFallbackSlotsContent();
  }
  render() {
    return html`<div class="crnt-form-control-validation-message" part="container">
			<slot name="icon"></slot>
			<slot></slot>
		</div>`;
  }
}

export { CrntFormControlValidationMessage };
